<template>
  <el-dialog
    class="rc-dialog"
    title="系统提示"
    :visible.sync="showCancelModal.flag"
    width="36%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="trainForm"
      ref="trainForm"
      >
      <el-row>
        <el-col :span="24">
          <el-form-item label-width="30px">
            <div class="el-message-box__status el-icon-warning"></div>
            <span style="margin-left: 32px">审批已通过，撤销需要再次审核</span>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="撤销理由：" prop="auditContent">
            <el-input
              v-model="trainForm.auditContent"
              maxlength="100"
              show-word-limit
              placeholder="请输入撤销理由"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24"  v-if="curItem.leaveType == 3">
          <el-form-item label-width="30px">
            <span>温馨提示：</span><br/>
            <span>1、该学员可能存在请假行为，请另行提交请假申请。</span><br/>
            <span>2、退学撤销通过后，学员结业状态会更新为“未结业”，如有需要请联系班级管理员手动调整。</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { cancelLeaveAudit } from "@/api/enrollment";
import rulesFactory from "@/utils/rules";
export default {
  props: {
    showCancelModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    curItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      trainForm: {
        auditContent: "",
      },
      rules: {
        auditContent: [rulesFactory.size('最多输入100个字', 0, 100)],
      },
    };
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit("closeCancelModal");
    },
    submit() {
      let params = {
        ...this.trainForm,
        uuid: this.curItem.uuid
      };
      cancelLeaveAudit(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.$emit("closeCancelModal");
        this.$parent.reload();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
    .form-select {
      width: 80%;
    }
  }
}
</style>
